import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

if( $( '.faq' ).length ) {

  function scrollListTop() {
    $([document.documentElement, document.body]).animate({
        scrollTop: $( '.faq' ).parent().offset().top
    });
  }

  function selectFAQ( elem ) {
    const dataSection = $( elem ).data( 'section' )

    $( '.faq-section-title' ).removeClass( 'active' )
    $( '.faq-wrapper' ).removeClass( 'active' )

    $( `[data-section=${dataSection}]` ).addClass( 'active' );

    ScrollTrigger.refresh();
  }

  function dropdown( elem ) {
    $( elem ).toggleClass( 'open' );

    if( $( elem ).hasClass( 'open' ) ) {
      $( elem ).css( 'max-height', $(elem)[0].scrollHeight );
    } else {
      $( elem ).css( 'max-height', '46px' );
    }
  }

  $( '.faq-section-title' ).on( 'click', ( e ) => { 
    selectFAQ( e.currentTarget );
    scrollListTop();
  } )

  $( '.faq-dropdown' ).on( 'click', ( e ) => {
    dropdown( e.currentTarget )
  } )
}

if( $( '.faq-sidebar' ).length ) {
  gsap.registerPlugin( ScrollTrigger );

  const faqSideBar = document.querySelector( '.faq-sidebar' );
  let sideBarHeight = $( faqSideBar ).find( '.wrapper' ).height() + 100;

  ScrollTrigger.create({
    trigger: $( '.faq' ),
    start: 'top top+=100',
    end: `bottom-=50 top+=${ sideBarHeight }`,
    pin: faqSideBar,
    pinSpacing: false
  })

  $( '.faq-list .accordion .title' ).on( 'click', () => {
    setTimeout( () => {
      ScrollTrigger.refresh();
    }, 200)
  } )
}

if( $( '.horizontal-scroll' ).length ) {
  gsap.registerPlugin( ScrollTrigger );

  let horizontalSection = document.querySelector( '.horizontal-scroll' )

  // create
  let mm = gsap.matchMedia();

  // add a media query. When it matches, the associated function will run
  mm.add("(min-width: 960px)", () => {
    gsap.to( horizontalSection, {
      x: () => horizontalSection.scrollWidth * -1,
      xPercent: 100,
      scrollTrigger: {
        trigger: '.horizontal-trigger',
        start: 'bottom bottom-=100',
        end: '+=2000px',
        pin: '.horizontal-trigger',
        scrub: true,
        invalidateOnRefresh: true
      }
    });
  });

}